import React from 'react';

import {
  Header,
  Container,
  StyledCard,
  SearchLightText,
  SearchLightLogo,
  PaddingContain
} from './Styled';

import Text from 'components/Text';
import ErrorMessage from 'components/ErrorMessage';
import LoadingSpinner, { LoadingContain } from 'components/LoadingSpinner';

import VerifyForm from './Form';

export const VerifyCard = ({
  errors,
  loading,
  onVerify
}) => (
  <Container>
    <StyledCard>
      <Header>
        <SearchLightLogo />
        <SearchLightText />
      </Header>
      <div>
        {loading
          ? <LoadingContain>
            <LoadingSpinner />
          </LoadingContain>
          : <React.Fragment>
            <PaddingContain>
              <Text.Default>Please enter and confirm a password for your account.</Text.Default>
            </PaddingContain>
            <VerifyForm
              errors={errors}
              onSubmit={onVerify}
            />
          </React.Fragment>}
      </div>
      <ErrorMessage />
    </StyledCard>
  </Container>
);

export default VerifyCard;
